/**
 * Utility wrapper for Hotjar events
 */

type HotjarFunction = {
  (...args: unknown[]): void;
  q?: unknown[][];
};

type HotjarWindow = Window & {
  hj?: HotjarFunction;
  _hjSettings?: {
    hjid: number;
    hjsv: number;
    hjDebug: boolean;
  };
};

export const initializeHotjar = (
  siteId: number,
  snippetVersion: number,
  debugMode: boolean
) => {
  const hotjarWindow = window as HotjarWindow;

  if (hotjarWindow.hj) {
    return;
  }

  const hj: HotjarFunction = (...args) => {
    hj.q = hj.q || [];
    hj.q.push(args);
  };

  hotjarWindow.hj = hj;
  hotjarWindow._hjSettings = {
    hjid: siteId,
    hjsv: snippetVersion,
    hjDebug: debugMode
  };

  const scriptPath = `https://static.hotjar.com/c/hotjar-${siteId}.js?sv=${snippetVersion}`;
  if (document.querySelector(`script[src="${scriptPath}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = scriptPath;
  document.head.appendChild(script);
};

export const dispatchHotjarIdentity = (userId: string) => {
  const { hj } = window as HotjarWindow;

  if (!hj) {
    if (process.env.DEPLOYMENT_ENV !== 'production') {
      console.warn('Hotjar not configured');
    }
    return;
  }

  return hj('identity', userId, {});
};
